import {RootState} from "../../types";
import {SettingsKeys} from "../../../../domain/settings/IAppSettingsRepo";

export const getSyncUUID = (state: RootState) => state.app.settings.get(SettingsKeys.syncUUID);